<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title></title>
<link href="style.css" rel="stylesheet" type="text/css"/>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="dedi"><i>For Kam and Nutan Chudasama, whose shop, open all hours and all weathers, is the beating heart of Kemble.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?a49d00cc